import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { ServiceRequestClaimDetailsInitStepDeclaration } from "./Steps/ServiceRequestClaimDetailsInitStep";

export const ServiceRequestClaimDetailsStartupFlow = new FlowDefinition("ServiceRequestClaimDetailsFlow");

ServiceRequestClaimDetailsStartupFlow.addStep(ServiceRequestClaimDetailsInitStepDeclaration);

ServiceRequestClaimDetailsStartupFlow.setStartStep("ServiceRequestClaimDetailsInit_Step");

export const RetrieveBookingStartupStepDefinition = new StepDefinition({
    stepName: "ServiceRequestClaimDetailsFlow",
    stepFlow: ServiceRequestClaimDetailsStartupFlow,
    contextIsolation: false
})
